import MainLayout from "@/layouts/MainLayout";
import { Box, Container, Typography } from "@mui/material";
import type { NextPage } from "next";
import { useTranslation } from "react-i18next";
import { PricingCardsSection } from "../PricingCardsSection";

export const ProductsPage: NextPage = () => {
  const { t, i18n } = useTranslation();
  return (
    <MainLayout footerBackgroundColor="primary.100">
      <Box sx={{ backgroundColor: "#FFF" }}>
        <Container sx={{ py: { xs: 3, md: 4, lg: 5 } }}>
          <Box display="flex" flexDirection={{ xs: "column" }}>
            {i18n.language === "th" && (
              <Typography variant="caption3" color="translucent.black.56">
                Our Product
              </Typography>
            )}
            <Typography variant="h2" color="common.darkblue" sx={{ mt: 1 }}>
              {t("product-heading.title")}
            </Typography>
          </Box>
        </Container>
      </Box>
      <PricingCardsSection />
    </MainLayout>
  );
};
